import { render, staticRenderFns } from "./activities.vue?vue&type=template&id=4bd4723e&scoped=true&"
import script from "./activities.vue?vue&type=script&lang=js&"
export * from "./activities.vue?vue&type=script&lang=js&"
import style0 from "./activities.vue?vue&type=style&index=0&id=4bd4723e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd4723e",
  null
  
)

export default component.exports